import React, { useMemo, useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import { axiosGateway } from "../../../../api/axios";
import "./InviteFriendsSection.css";
import inviteMailGmailIcon from "../../../../assets/icons/svg/invite-mail-gmail.svg";
import inviteSendWhiteIcon from "../../../../assets/icons/svg/invite-send-white.svg";

const SERVICE_ID = "service_j6fk5ml";
const TEMPLATE_ID = "template_uplzaid";
const PUBLIC_KEY = "KeLD0RHINxsuFLiU9";

const InviteFriendsSection = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "success" | "error"

  const canSend = useMemo(() => email.trim().length > 0, [email]);

  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleSendInvite = async () => {
    if (!canSend) return;

    try {
      const response = await axiosGateway.post("/referrals/invitations", {
        inviteeEmail: email.trim(),
      });
      const token = response.data?.data?.token;
      if (!token) throw new Error("Referral token missing");

      const invitationLink = `${window.location.origin}/SignupPatient?ref=${encodeURIComponent(token)}`;
      const templateParams = {
        email: email.trim(),
        invitation_link: invitationLink,
        referral_link: invitationLink,
      };

      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
        setStatus("success");
        setEmail("");
        setTimeout(() => setStatus(""), 3000);
    } catch (error) {
      console.error("Invitation error:", error);
      setStatus("error");
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSendInvite();
  };

  return (
    <div className="invite-friends-container">
      <div className="invite-header">
        <img src={inviteMailGmailIcon} className="mail-icon" alt="" aria-hidden="true" />

        <h3 className="invite-title">{t("invite.title")}</h3>
      </div>

      <p className="invite-description">{t("invite.description")}</p>

      <div className="email-section">
        <h4 className="email-title">{t("invite.emailTitle")}</h4>

        <div className="email-input-container">
          <input
            type="email"
            className="email-input"
            placeholder={t("invite.emailPlaceholder")}
            value={email}
            onChange={handleEmailChange}
            onKeyDown={handleKeyDown}
            aria-label={t("invite.emailAria")}
          />

          <button
            className="send-button"
            onClick={handleSendInvite}
            aria-label={t("invite.sendAria")}
            disabled={!canSend}
            type="button"
            title={t("invite.send")}
          >
            <img src={inviteSendWhiteIcon} className="send-icon" alt="" aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* Centered message overlay */}
      {status && (
        <div className={`message-overlay ${status}`}>
          {status === "success" ? t("invite.success") : t("invite.error")}
        </div>
      )}
    </div>
  );
};

export default InviteFriendsSection;
